import React from 'react'

function GOATMovie(props) {
  const { GOAT, handleGOAT, sortGOATReset, label, DefaultValue, statusType } = props

  const handleReset = () => {
    // Reset the value of checkPopularMovie when the button is clicked
    handleGOAT({ target: { value: '' } })
    sortGOATReset() // Call the reset function
  }

  return (
    <div className='agerestriction'>
      <label>{label}</label>
      <div className='d-flex'>
        <select
          disabled={statusType === 'draft'}
          defaultValue={''}
          value={GOAT}
          onChange={e => handleGOAT(e)}
          required
          name='select'
          id='languages'
        >
          <option value='' disabled selected>
            {DefaultValue}
          </option>
          <option value='true' selected={GOAT === 'true'}>
            True
          </option>
        </select>
        <button
          style={{ padding: '1px 7px', marginLeft: '4px' }}
          onClick={() => handleReset()}
          className='btn btn-primary'
        >
          x
        </button>
      </div>
    </div>
  )
}

export default GOATMovie
